import { render, staticRenderFns } from "./list-delivery-form.vue?vue&type=template&id=444d231d&"
import script from "./list-delivery-form.vue?vue&type=script&lang=js&"
export * from "./list-delivery-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports